import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Injector,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { ExtranetMenuService } from '@core/services/extranet-menu.service';
import { environment } from '@env';
import { ExtranetAuthenticationService } from '@src/app/core/services/extranet-authentication.service';
import { HeaderService } from '@src/app/core/services/header.service';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  AuthenticationService,
  BaseComponent,
  Configuration,
  StorageService,
} from 'sigv-library';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  isMenuVisible$ = this.extranetMenuService.getSideMenuObservable();
  isHeaderVisible$ = this.headerService.getHeaderObservable();
  breadcrumb$ = this.breadcrumbService.getBreadcrumbsObservable();

  private killTrigger: Subject<void> = new Subject();
  private refreshTokenTimer$ = timer(1800000, 1800000).pipe(
    takeUntil(this.killTrigger)
  );

  private timeoutID?: any;

  constructor(
    protected injector: Injector,
    private extranetMenuService: ExtranetMenuService,
    private authenticationService: AuthenticationService,
    private headerService: HeaderService,
    private extranetAuthenticationService: ExtranetAuthenticationService,
    private router: Router,
    private configuration: Configuration,
    private storageService: StorageService,
    private cdr: ChangeDetectorRef,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.isMenuVisible$.subscribe(z=>{
      this.cdr.detectChanges();
    });

    this.isHeaderVisible$.subscribe(z=>{
      this.cdr.detectChanges();
    });

    this.breadcrumb$.subscribe(z=>{
        this.cdr.detectChanges();
    });

    this.idleLogOut();

    if (!environment.isExtranet && this.appConfig.getAzureAD().enabled) {
      this.logger.info('Intranet login and enable azure ad');
      this.refreshTokenTimer$.subscribe({
        next: () => {
          this.authenticationService.refreshToken();
        },
        error: (err) => {
          this.logger.error('Layout Component - refreshToken', err);
        },
      });
    }

    // 當瀏覽器不同分頁登入或登出時，重整頁面
    window.addEventListener(
      'storage',
      (event) => {
        const isUserNoSame =
          this.authenticationService.currentUserValue?.userNo ===
          this.storageService.local.getItem(
            this.storageService.keys.UserProfile
          )?.userNo;

        if (event.storageArea === localStorage) {
          if (
            this.authenticationService.isAuthenticated === false ||
            !isUserNoSame
          ) {
            window.location.reload();
          }
        }
      },
      false
    );
  }

  ngOnDestroy(): void {
    this.clearTimeout();
    this.killTrigger.next();
    this.killTrigger.complete();
  }

  @HostListener('mousemove', ['$event'])
  @HostListener('document:keydown', ['$event'])
  idleLogOut(): void {
    if (environment.isExtranet) {
      this.clearTimeout();
      this.timeoutID = setTimeout(() => {
        this.extranetAuthenticationService.logout();
        this.router.navigate([this.configuration.routePath.login]);
      }, 1200000);
    }
  }

  clearTimeout(): void {
    if (this.timeoutID !== undefined) {
      clearTimeout(this.timeoutID);
    }
  }
}
